module.exports = __webpack_public_path__ + "gd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gd.svg
// module id = 812
// module chunks = 0